module.exports = __webpack_public_path__ + "img/LSS-logo.1fef5cbc.svg";